import { Button, Typography } from "@mui/material";

import { useTeachingPolicy } from "../../../../../hooks/useTeachingPolicy";

export function GoogleCalendarSetting() {
	const { policy, linkWithGoogleCalendar, unlinkWithGoogleCalendar } =
		useTeachingPolicy();

	const onClickLinkWithGoogleCalendar = async () => {
		const authURL = await linkWithGoogleCalendar();
		if (authURL) {
			window.open(authURL);
		}
	};

	if (!policy) {
		return null;
	}

	return (
		<div className="section-separator">
			<Typography className="small-title-text bold">Google Calendar</Typography>
			<Typography className="normal-text item-separator-tiny">
				Do you want to link with your Google Calendar?
			</Typography>

			{policy.calendarToken !== "CONNECTED" && (
				<Button
					className="normal-button primary-button no-transform item-separator-small"
					onClick={onClickLinkWithGoogleCalendar}>
					Link with Google Calendar
				</Button>
			)}

			{policy.calendarToken === "CONNECTED" && (
				<Button
					className="normal-button primary-button no-transform item-separator-small"
					onClick={unlinkWithGoogleCalendar}>
					Unlink with Google Calendar
				</Button>
			)}
		</div>
	);
}
